
import { Component, Vue } from "vue-property-decorator";
import LoginForm from "@/components/forms/LoginForm.vue";
import NotAuthHeader from "@/components/NotAuthHeader.vue";
import ManagementFooter from "@/components/ManagementFooter.vue";

@Component({
  components: {
    LoginForm,
    NotAuthHeader,
    ManagementFooter,
  },
})
export default class Login extends Vue {}
